'use client';

import { ReactNode } from 'react';
import { useAuthSync } from '@/entities/auth/model/useAuth';

export function AuthProvider({ children }: { children: ReactNode }) {
  useAuthSync();
  return <>{children}</>;
}
